import store from "../config/configureStore";
import { serviceNames } from "../utils/constants";

const GET_AMS_DICTIONARY = "GET_AMS_DICTIONARY";
const GET_AMS_PERMISSIONS = "GET_AMS_PERMISSIONS";
const ADD_AMS_DICTIONARY_VALUE = "ADD_AMS_DICTIONARY_VALUE";
const UPDATE_AMS_DICTIONARY_VALUE = "UPDATE_AMS_DICTIONARY_VALUE";
const GET_AMS_USERS = "GET_AMS_USERS";

export const getDictionary = (dictionary) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) throw new Error("Websocket client not available");
  return client.service(serviceNames.amsDictionary).get(dictionary);
};

export const getDictionaries =
  (options = "ams") =>
  async (dispatch) => {
    const client = store.store.getState().websocket.websocket;
    const userAgency = store.store.getState().user?.userAgency;
    const service = client.service(serviceNames.amsDictionary);
    service.timeout = 20000;
    try {
      const { dictionary, permissions } = await service.find({
        query: { options, agencyId: userAgency },
      });
      dispatch({ type: GET_AMS_DICTIONARY, payload: dictionary });
      dispatch({ type: GET_AMS_PERMISSIONS, payload: permissions });
    } catch (err) {
      console.error("AMS dictionary error", err);
    }
  };

export const getUsers = () => async (dispatch) => {
  const client = store.store.getState().websocket.websocket;
  const service = client.service(serviceNames.settingsSecuritySearchUsersAms);
  service.timeout = 20000;
  try {
    const users = await service.find();
    const usersMap = {};
    users?.forEach((user) => {
      usersMap[user.ptsUserID] = user.Username;
    });
    dispatch({ type: GET_AMS_USERS, payload: usersMap });
  } catch (err) {
    console.error("AMS getUsers error", err);
  }
};

export const saveDictionary = (dictionary, data) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) throw new Error("Websocket client not available");
  const svc = client.service(serviceNames.amsDictionary);

  return data.ROWGUID
    ? svc.patch(dictionary, data)
    : svc.create({ data, dictionary });
};

export const deleteDictionary = (dictionary, ROWGUID) => {
  const client = store.store.getState().websocket.websocket;
  if (!client) throw new Error("Websocket client not available");
  return client
    .service(serviceNames.amsDictionary)
    .remove(dictionary, { query: { ROWGUID } });
};

export const addDictionaryValue = (value, name) => ({
  type: ADD_AMS_DICTIONARY_VALUE,
  payload: { value, name },
});

export const updateDictionaryValue = (value, name) => ({
  type: UPDATE_AMS_DICTIONARY_VALUE,
  payload: { value, name },
});

const initialState = {
  dictionary: {},
  permissions: {},
  users: {},
};

export default function DictionaryReducer(state = initialState, action) {
  switch (action.type) {
    case GET_AMS_DICTIONARY:
      return {
        ...state,
        dictionary: {
          ...state.dictionary,
          ...action.payload,
        },
      };

    case GET_AMS_PERMISSIONS:
      return {
        ...state,
        permissions: {
          ...state.permissions,
          ...action.payload,
        },
      };

    case ADD_AMS_DICTIONARY_VALUE:
      return {
        ...state,
        dictionary: {
          ...state.dictionary,
          [action.payload.name]: [
            action.payload.value,
            ...(state.dictionary[action.payload.name] || []),
          ],
        },
      };

    case UPDATE_AMS_DICTIONARY_VALUE:
      return {
        ...state,
        dictionary: {
          ...state.dictionary,
          [action.payload.name]: [...action.payload.value],
        },
      };

    case GET_AMS_USERS:
      return {
        ...state,
        users: { ...action.payload },
      };

    default:
      return state;
  }
}
